export default __webpack_public_path__ + "static/media/20-Yandex.3b00c611.png";